import { getUniqueArray } from "../../../common/utils/helpers/getUniqueArray";

// methods which returns unique array of files for upload
export const getAcceptedFiles = (existingFiles: any, acceptedFiles: any, maxFiles: any) => {
  const mergedFiles = existingFiles.concat(acceptedFiles);
  const uniqueMergedFiles = getUniqueArray(mergedFiles, "path");
  uniqueMergedFiles.splice(maxFiles, mergedFiles.length - maxFiles);
  return uniqueMergedFiles;
};
